export const generalKey = 'product_spu_in001';
export const whiteLocaleList = ['us']; //白名单
export const productPageUrl = 'stream-microinverter';
export const tabsValues = ['Product', 'Bundles'];
export const productPageTheme = 'white'; //主题色
